


$(function(){
    $("#datepicker-from").datepicker({
        dateFormat: 'dd.mm.yy',
    });
});

$(function(){
    $("#datepicker-to").datepicker({
        dateFormat: 'dd.mm.yy',
    });
});